import Vue from 'vue';
import NoSSR from 'vue-no-ssr';
import { EventBus } from '@/eventBus';

import createRouter from './router';
import createStore from './store';

import App from './views/App.vue';

import Loading from './views/components/Loading';
import ConditionalIcon from './views/components/ConditionalIcon';
import ActionButton from '@/views/components/ActionButton';
import SubmitButton from './views/components/SubmitButton';
import SlugField from './views/components/SlugField';
import TextareaCounterField from './views/components/TextareaCounterField';
import Toasts from './views/layouts/Toasts';
import Drawer from './views/layouts/Drawer';
import Date from './views/components/Date';
import DatePicker from './views/components/DatePicker';
import RelativeDate from './views/components/RelativeDate';
import NothingHere from './views/components/NothingHere';
import BigNotice from './views/components/BigNotice';
import FormErrors from './views/components/FormErrors';
import FieldErrors from './views/components/FormFieldErrors';
import InputToolTip from './views/components/InputToolTip';
import Selectize from './views/components/Selectize';
import SlideUpDown from './views/components/SlideUpDown';
import ModuleField from './views/sections/app/modules/components/functional/ModuleField';

import Vuelidate from 'vuelidate';
import '@/filters';
import ListenerMixin from '@/mixins/ListenerMixin';

import Vue2Filters from 'vue2-filters';
import Sortable from 'sortablejs';

import MaskedInput from 'vue-text-mask';
import { mapGetters } from 'vuex';

Vue.use(Vuelidate);
Vue.use(Vue2Filters);

/**
 * Global ListenerMixin applied to every component
 * All components will now have access to root listeners
 */
Vue.mixin(ListenerMixin);

Vue.directive('sortable', {
	inserted: function(el, binding) {
		el.sortable = Sortable.create(el, binding.value || {});
	},
	update: function(el, binding) {
		Object.keys(binding.value).forEach(key => {
			el.sortable.option(key, binding.value[ key ]);
		});
	},
});

import './registerServiceWorker';

Vue.config.productionTip = false;

if (process.client) {
	require('./bootstrap.client');
}

Vue.component('masked-input', MaskedInput);
Vue.component('no-ssr', NoSSR);
Vue.component('selectize', Selectize);
Vue.component('loading', Loading);
Vue.component('conditional-icon', ConditionalIcon);
Vue.component('action-button', ActionButton);
Vue.component('submit-button', SubmitButton);
Vue.component('slug-field', SlugField);
Vue.component('textarea-counter-field', TextareaCounterField);
Vue.component('toasts', Toasts);
Vue.component('drawer', Drawer);
Vue.component('date', Date);
Vue.component('relative-date', RelativeDate);
Vue.component('nothing-here', NothingHere);
Vue.component('big-notice', BigNotice);
Vue.component('form-errors', FormErrors);
Vue.component('field-errors', FieldErrors);
Vue.component('input-tooltip', InputToolTip);
Vue.component('slide-up-down', SlideUpDown);
Vue.component('module-field', ModuleField);
Vue.component('date-picker', DatePicker);

// Automatically import all Vue files within /nav/ folders
const NavFiles = require.context('./', true, /views\/.*\/nav\/.*\.vue/i);
NavFiles.keys().map(key => Vue.component(key.split('/').pop().split('.')[ 0 ], NavFiles(key).default));

export default () => {
	const store = createStore();
	const router = createRouter();

	if (process.client) {
		const init = require('./init').default;
		init({ router, store });
	}

	return new Vue({
		router,
		store,

		created() {
			this.startRootListeners();
			this.startRecurringDataSync();
			window.logout = async () => {
				this.$api.post('/logout');
			};
		},

		// beforeDestroy() {
		// 	this.$broadcaster.disconnect();
		// },

		computed: mapGetters(['isSuperAdmin']),

		methods: {

			startRootListeners() {
				EventBus.$on('go', path => {
					this.$router.push(path);
				});

				EventBus.$on('close-all-drawers', () => {
					this.$root.$emit('close-all-drawers');
				});

				EventBus.$on('content-updated', () => {
					this.$store.dispatch('siteContentUpdated');
				});
			},

			/**
			 * Regularly sync data that is used on every page
			 */
			startRecurringDataSync() {
				if (process.client) {
					setInterval(() => this.syncAccountData(), 1000 * 180);
				}
			},

			syncAccountData() {
				console.log('syncAccountData main.js');
				if (store.getters.isLoggedIn) {
					try {
						store.dispatch('syncAccountData');
					} catch(e) {
						// TODO - We need to direct to a 500 page?
						// TODO - Update API to extract failure cause so we don't override a logout redirect with a 500
					}
				}
			},

		},

		render: h => h(App),
	});
};
